import PropTypes from 'prop-types';
import React from 'react';
import Modal from '../titled-modal/titled-modal.jsx';
import Box from '../box/box.jsx';
import SelectedDisguisedBlock from '../disguised-block/selected-disguised-block.jsx'
import {defineMessages, injectIntl, intlShape, FormattedMessage} from 'react-intl';
import booleanInputIcon from './icon--boolean-input.svg';
import textInputIcon from './icon--text-input.svg';
import dropdownInputIcon from './icon--dropdown-input.svg';
import labelIcon from './icon--label.svg';
import classnames from 'classnames'
import styles from './custom-procedures.css';
import { getMode } from '../../lib/hetao-mode.js';

const mode = getMode();

const messages = defineMessages({
    myblockModalTitle: {
        defaultMessage: 'Make a Block',
        description: 'Title for the modal where you create a custom block.',
        id: 'gui.customProcedures.myblockModalTitle'
    }
});

export const DISGUISED_CLICKING_TYPES = {
    CHANGE: "CHANGE",
    CREATING: "CREATING"
}

const getCategoriesLabel = (id) => {
    switch (id) {
        case Blockly.Categories.motion:
            return Blockly.Msg.CATEGORY_MOTION;
        case Blockly.Categories.looks:
            return Blockly.Msg.CATEGORY_LOOKS;
        case Blockly.Categories.sound:
            return Blockly.Msg.CATEGORY_SOUND;
        case Blockly.Categories.event:
            return Blockly.Msg.CATEGORY_EVENTS;
        case Blockly.Categories.control:
            return Blockly.Msg.CATEGORY_CONTROL;
        case Blockly.Categories.sensing:
            return Blockly.Msg.CATEGORY_SENSING;
        case Blockly.Categories.operators:
            return Blockly.Msg.CATEGORY_OPERATORS;
    }
}

const CustomProcedures = props => {
    const categories = [
        {
            id: '',
            label: "无"
        },
        ...Blockly.ScratchBlocks.ProcedureUtils.Categories.map((categoryId) => ({
            id: categoryId,
            label: getCategoriesLabel(categoryId)
        }))
    ]

    return <React.Fragment>
        <Modal
            className={styles.modalContent}
            contentLabel={props.intl.formatMessage(messages.myblockModalTitle)}
            onRequestClose={props.onCancel}
        >
            <Box
                className={styles.workspace}
                componentRef={props.componentRef}
            />
            <Box className={styles.body}>
                <div className={styles.optionsRow}>
                    <div
                        className={styles.optionCard}
                        role="button"
                        tabIndex="0"
                        onClick={props.onAddTextNumber}
                    >
                        <img
                            className={styles.optionIcon}
                            src={textInputIcon}
                        />
                        <div className={styles.optionTitle}>
                            <FormattedMessage
                                defaultMessage="Add an input"
                                description="Label for button to add a number/text input"
                                id="gui.customProcedures.addAnInputNumberText"
                            />
                        </div>
                        <div className={styles.optionDescription}>
                            <FormattedMessage
                                defaultMessage="number or text"
                                description="Description of the number/text input type"
                                id="gui.customProcedures.numberTextType"
                            />
                        </div>
                    </div>
                    <div
                        className={styles.optionCard}
                        role="button"
                        tabIndex="0"
                        onClick={props.onAddBoolean}
                    >
                        <img
                            className={styles.optionIcon}
                            src={booleanInputIcon}
                        />
                        <div className={styles.optionTitle}>
                            <FormattedMessage
                                defaultMessage="Add an input"
                                description="Label for button to add a boolean input"
                                id="gui.customProcedures.addAnInputBoolean"
                            />
                        </div>
                        <div className={styles.optionDescription}>
                            <FormattedMessage
                                defaultMessage="boolean"
                                description="Description of the boolean input type"
                                id="gui.customProcedures.booleanType"
                            />
                        </div>
                    </div>
                    <div
                        className={styles.optionCard}
                        role="button"
                        tabIndex="0"
                        onClick={props.onAddLabel}
                    >
                        <img
                            className={styles.optionIcon}
                            src={labelIcon}
                        />
                        <div className={styles.optionTitle}>
                            <FormattedMessage
                                defaultMessage="Add a label"
                                description="Label for button to add a label"
                                id="gui.customProcedures.addALabel"
                            />
                        </div>
                    </div>
                    {mode === "TEACHER" && (
                        <div
                            className={classnames(styles.optionCard, styles.optionCardDropdown)}
                            role="button"
                            tabIndex="0"
                            onClick={props.onAddDropdown}
                        >
                            <div  className={styles.optionCardNew}>New</div>
                            <img
                                className={styles.optionIcon}
                                src={dropdownInputIcon}
                            />
                            <div className={styles.optionTitle}>
                                <FormattedMessage
                                    defaultMessage="Add an input"
                                    description="Label for button to add a number/text input"
                                    id="gui.customProcedures.addAnInputNumberText"
                                />
                            </div>
                            <div className={styles.optionDescription}>
                                下拉框
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.checkboxRow}>
                    <label>
                        <input
                            checked={props.warp}
                            type="checkbox"
                            onChange={props.onToggleWarp}
                        />
                        <FormattedMessage
                            defaultMessage="Run without screen refresh"
                            description="Label for checkbox to run without screen refresh"
                            id="gui.customProcedures.runWithoutScreenRefresh"
                        />
                    </label>
                </div>
                <Box direction="column" className={
                    classnames(styles.disguiseBlockContainer, {
                        [styles.show]: props.disguisedBlockConfigurable
                    })
                }>
                    <Box flex direction={"row"} alignItems={"center"}>
                        <strong> 将该代码块伪装成 </strong>
                        {
                            props.selectedDisguisedBlock ? <Box flex alignItems={"center"}>
                                <SelectedDisguisedBlock
                                    value={props.selectedDisguisedBlock}
                                />
                                <button
                                    className={styles.okButton}
                                    onClick={() => props.onOpenDisguiseBlockModal(DISGUISED_CLICKING_TYPES.CHANGE)}
                                >
                                    修改
                                </button>
                            </Box> : <button
                                className={styles.okButton}
                                onClick={() => props.onOpenDisguiseBlockModal(DISGUISED_CLICKING_TYPES.CREATING)}
                            >
                                选择积木块
                            </button>
                        }
                    </Box>
                    {mode === "TEACHER" && (
                        <Box flex direction={"row"} alignItems={"center"}>
                            <strong> 代码块类别 (配置类别后才能设置默认值) </strong>
                            <select
                                className={styles.categorySelect}
                                value={props.category}
                                onChange={(e) =>
                                    props.onSetCategory(
                                        e.currentTarget.value
                                    )
                                }
                            >
                                {categories.map((category) => (
                                    <option value={category.id}>
                                        {category.label}
                                    </option>
                                ))}
                            </select>
                        </Box>
                    )}
                </Box>
                <Box className={styles.buttonRow}>
                    <button
                        className={styles.cancelButton}
                        onClick={props.onCancel}
                    >
                        <FormattedMessage
                            defaultMessage="Cancel"
                            description="Label for button to cancel custom procedure edits"
                            id="gui.customProcedures.cancel"
                        />
                    </button>
                    <button
                        className={styles.okButton}
                        onClick={props.onOk}
                    >
                        <FormattedMessage
                            defaultMessage="OK"
                            description="Label for button to save new custom procedure"
                            id="gui.customProcedures.ok"
                        />
                    </button>
                </Box>
            </Box>
        </Modal>
    </React.Fragment>
}

CustomProcedures.propTypes = {
    componentRef: PropTypes.func.isRequired,
    intl: intlShape,
    category: PropTypes.string.isRequired,
    onAddBoolean: PropTypes.func.isRequired,
    onAddLabel: PropTypes.func.isRequired,
    onAddTextNumber: PropTypes.func.isRequired,
    onAddDropdown: PropTypes.func.isRequired,
    onSetCategory: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    selectedDisguisedBlock: PropTypes.string.isRequired,
    onDisguiseBlock: PropTypes.func.isRequired,
    onToggleWarp: PropTypes.func.isRequired,
    warp: PropTypes.bool.isRequired,
    onOpenDisguiseBlockModal: PropTypes.func.isRequired
};

export default injectIntl(CustomProcedures);
